import { IconReportMoney, IconTagStarred } from '@tabler/icons-react';
import type { NavTransactionType } from 'helpers/useNavTransactions';

export const navTransactionIcon = (type: NavTransactionType) =>
  type === 'purchase' ? IconTagStarred : IconReportMoney;
